import { LaptopAccountIcon } from './LaptopAccountIcon';

/**
 * author: John Brissette
 * id 63808048-CB00-41F6-AE66-3CB683197A9E
 * name laptop-account
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/laptop-account.svg
 * tags
 * - Account / User 
 * - Device / Tech 
 */
export const TeleconferenceIcon = LaptopAccountIcon;
export default TeleconferenceIcon